var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M3.515 13.414l9.9-9.9a1 1 0 0 0-1.328-1.491L12 2.1 2.1 12a1 1 0 0 0 1.327 1.492l.088-.078 9.9-9.9-9.9 9.9zm2.828 2.829l9.9-9.9a1 1 0 0 0-1.327-1.492l-.088.078-9.9 9.9a1 1 0 0 0 1.328 1.491l.087-.077 9.9-9.9-9.9 9.9zm2.829 2.828l9.9-9.9a1 1 0 0 0-1.328-1.491l-.087.077-9.9 9.9a1 1 0 0 0 1.327 1.492l.088-.078 9.9-9.9-9.9 9.9zM12 21.9L21.9 12a1 1 0 0 0-1.327-1.492l-.088.078-9.9 9.9a1 1 0 0 0 1.328 1.491L12 21.9 21.9 12 12 21.9z" })
  );
});